import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { LocalService } from './local.service';

export type ApplicationTheme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);

  constructor(private readonly localService: LocalService) {}

  get currentTheme(): ApplicationTheme {
    return this.document.documentElement.classList.contains('sokrates-super-dark')
      ? 'dark'
      : 'light';
  }

  initialize(): void {
    this.setTheme(this.localService.getData('theme') === 'dark' ? 'dark' : 'light');
  }

  toggleTheme(): void {
    this.setTheme(this.currentTheme === 'dark' ? 'light' : 'dark');
  }

  setTheme(theme: ApplicationTheme): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.document.documentElement.classList.toggle('sokrates-super-dark', theme === 'dark');
    this.localService.saveData('theme', theme);
  }
}
